import formatName from 'I18n/utils/formatName';

// @ts-expect-error no types
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { Media } from 'foundations-components/transitional/components/Media';
import { MediaBody } from 'foundations-components/transitional/components/MediaBody';
import { MediaLeft } from 'foundations-components/transitional/components/MediaLeft';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Small } from 'foundations-components/transitional/components/Small';
import { useFetchOwner } from './hooks/useFetchOwner';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CampaignsPlatformLabelPopoverOwner({
  ownerId
}) {
  const {
    data,
    loading
  } = useFetchOwner({
    ownerId
  });
  if (loading || !data) {
    return null;
  }
  const name = formatName({
    firstName: data.firstName,
    lastName: data.lastName
  });
  return /*#__PURE__*/_jsxs(Media, {
    align: "center",
    "data-test-id": "user-avatar",
    children: [data.email && /*#__PURE__*/_jsx(MediaLeft, {
      children: /*#__PURE__*/_jsx(UIAvatar, {
        displayName: data.email,
        lookup: {
          type: 'hubSpotUserEmail',
          primaryIdentifier: data.email
        }
      })
    }), /*#__PURE__*/_jsxs(MediaBody, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h6",
        children: /*#__PURE__*/_jsx(TruncateString, {
          children: name !== null && name.length > 0 ? name : data.email
        })
      }), data.email && /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(TruncateString, {
          tooltip: /*#__PURE__*/_jsx(Text, {
            color: "text-core-on-fill-default",
            children: data.email
          }),
          children: /*#__PURE__*/_jsx(Text, {
            typography: "detail-200",
            color: "icon-core-subtle",
            children: data.email
          })
        })
      })]
    })]
  });
}